var $ = require('jquery');

var selectors = {
    module: '.modulelt.n',
    moduleType: '[data-moduletype="text"], [data-moduletype="header"]',
    placeholder: 'span.diysemanticplaceholder',
    semanticDataName: '[data-semantic-data-key="{name}"]'
};

/** @public */
var refresher = {

    /**
     * Updates DOM placeholders with new data.
     * @param {object} data
     * @public
     */
    update: function(data) {
        var i, len, items, $placeholders;

        $placeholders = $(selectors.module)
            .filter(selectors.moduleType)
            .find(selectors.placeholder);

        items = data.entities;

        len = items.length;

        for (i = 0; i < len; i++) {
            $placeholders
                .filter(selectors.semanticDataName.replace('{name}', items[i].name))
                .each(function () {
                    var newvalue, check = '';
                    newvalue = items[i].localizedValue || items[i].value;
                    newvalue = newvalue || '&nbsp;';

                    if (typeof newvalue === 'object') {
                        for (var key in newvalue) {
                            if (newvalue.hasOwnProperty(key)) {
                                check += (newvalue[key] || '');
                            }
                        }
                        if (!check) {
                            newvalue = '&nbsp;';
                        }
                    }
                    $(this).html(newvalue);
                });
        }
    }
};

module.exports = refresher;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/semanticdata/refresher/refresher.js
 ** module id = 7
 ** module chunks = 0 4
 **/